import React, { useState, useEffect } from "react";
import "./faq.css";
import AOS from "aos";
import "aos/dist/aos.css";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  // Toggle Question
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Initialize AOS Animation
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  // ---- Fazo Academy FAQs ----
  const academyFAQs = [
    {
      q: "1. What programs does Fazo Academy offer?",
      a: "Fazo Academy offers a wide range of programs including software development, data science, digital marketing, and more. Our flagship program is the testing training course.",
    },
    {
      q: "2. Are the courses at Fazo Academy accredited?",
      a: "Yes, our courses are accredited and recognized within the industry. We maintain high standards of education and curriculum development.",
    },
    {
      q: "3. Is financial aid available for students?",
      a: "Yes, Fazo Academy offers flexible payment options and financial aid for eligible students, including scholarships and grants.",
    },
    {
      q: "4. Are there any prerequisites for enrolling in courses?",
      a: "Prerequisites vary depending on the course. Some may require prior knowledge or experience. Our counselors can guide you accordingly.",
    },
    {
      q: "5. Do you offer job placement assistance?",
      a: "Yes, Fazo Academy provides job placement assistance through career services, resume workshops, and interview training.",
    },
  ];

  // ---- Automation Testing FAQs ----
const javaFAQs = [
  {
    q: "1. What is the Java Course at Fazo Academy?",
    a: "The Java Course at Fazo Academy is a comprehensive training program designed to teach students the fundamentals of Java programming language and its applications in software development.",
  },
  {
    q: "2. Who is the Java Course suitable for?",
    a: "The Java Course is suitable for beginners who have little to no programming experience as well as experienced programmers looking to expand their skill set with Java. Whether you're new to coding or seeking to advance your career, this course provides a solid foundation in Java programming.",
  },
  {
    q: "3. What will I learn in the Java Course?",
    a: "Throughout the course, you will learn the core concepts of Java programming, including syntax, data types, control flow, object-oriented programming principles, and more. You'll also gain practical experience by working on hands-on projects and assignments.",
  },
  {
    q: "4. Are there any prerequisites for enrolling in the Java Course?",
    a: "There are no specific prerequisites for enrolling in the Java Course. However, basic computer literacy and a willingness to learn are recommended. Our instructors will guide you through the fundamentals of programming and Java language concepts.",
  },
  {
    q: "5. Is the Java Course available online or in-person?",
    a: "Fazo Academy offers both online and in-person options for the Java Course to accommodate different learning preferences and schedules. You can choose the format that best suits your needs.",
  },
  {
    q: "6. How long is the Java Course?",
    a: "The duration of the Java Course may vary depending on the format (full-time, part-time) and specific schedule. Typically, the course ranges from several weeks to a few months, allowing students to learn at a comfortable pace while covering all essential topics thoroughly.",
  },
  {
    q: "7. What career opportunities can I pursue after completing the Java Course?",
    a: "Graduates of the Java Course at Fazo Academy can pursue various career paths in software development, including Java developer, software engineer, web developer, and more. Java is widely used in enterprise applications, web development, mobile app development, and other areas, offering numerous job opportunities.",
  },
  {
    q: "8. Does Fazo Academy offer job placement assistance for graduates of the Java Course?",
    a: "Yes, Fazo Academy provides job placement assistance to graduates through our dedicated career services team. We offer resume building workshops, interview preparation, networking opportunities, and connections to our extensive employer network to help students secure employment after completing the course.",
  },
];
  // ---- Training Method FAQs ----
  const trainingFAQs = [
    {
      q: "1. What training methods does Fazo Academy use?",
      a: "We use interactive lectures, projects, peer collaboration, mentorship, and flexible learning options.",
    },
    {
      q: "2. Are the lectures interactive?",
      a: "Yes, our lectures encourage active engagement and collaboration between students and instructors.",
    },
    {
      q: "3. How are hands-on projects incorporated?",
      a: "Projects simulate real-world challenges to reinforce learning and build strong portfolios.",
    },
    {
      q: "4. Is peer collaboration encouraged?",
      a: "Yes, team collaboration helps share knowledge and improve learning outcomes.",
    },
    {
      q: "5. Do students receive one-on-one mentorship?",
      a: "Yes, personalized mentorship is part of every student’s journey at Fazo Academy.",
    },
    {
      q: "6. How is the curriculum updated?",
      a: "Our curriculum is regularly revised to reflect the latest industry technologies and best practices.",
    },
    {
      q: "7. Does Fazo Academy offer flexible learning options?",
      a: "Yes, we offer part-time, full-time, online, and in-person training modes.",
    },
    {
      q: "8. Are there opportunities for practical application?",
      a: "Absolutely. Students work on coding exercises, simulations, and real-world case studies.",
    },
  ];

  const categories = [
    { title: "FAQs about Fazo Academy", data: academyFAQs },
    { title: "FAQs about Java Course at Fazo Academy", data: javaFAQs },
    { title: "FAQs about Training Methods", data: trainingFAQs },
  ];

  return (
    <div className="faq-section-one">
      <div className="container">
        <section className="section-margin" data-aos="fade-up">
          <div className="headlines-for-all">
            <h4>
              <span>Frequently</span> Asked Questions
            </h4>
            <p>
              Find answers to the most common questions about our courses,
              learning process, certifications, and career support.
            </p>
          </div>
        </section>

        <div className="faq-container">
          {categories.map((cat, catIndex) => (
            <div
              className="faq-category"
              key={catIndex}
              // data-aos="fade-up"
              // data-aos-delay={catIndex * 200}
            >
              <h2 className="faq-title">{cat.title}</h2>

              {cat.data.map((item, index) => {
                const itemIndex = `${catIndex}-${index}`;
                const isOpen = openIndex === itemIndex;

                return (
                  <div className="faq-item" key={itemIndex}>
                    <button
                      className={`faq-question ${isOpen ? "active" : ""}`}
                      onClick={() => toggleFAQ(itemIndex)}
                      // data-aos="fade-up"
                    >
                      {item.q}
                      <span className="arrow">{isOpen ? "▲" : "▼"}</span>
                    </button>

                    <div
                      className="faq-answer"
                      style={{
                        maxHeight: isOpen ? "500px" : "0",
                        opacity: isOpen ? "1" : "0",
                        transition: "all 0.4s ease",
                      }}
                    >
                      <p>{item.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
